/** Thrown when a dash-meta endpoint returns 429. */
export class DashMetaRateLimitError extends Error {
  /** Seconds the client should wait before retrying, from the `Retry-After` header. */
  readonly retryAfterSeconds: number;

  constructor(retryAfterSeconds: number) {
    super('Dash-meta request rate-limited');
    this.name = 'DashMetaRateLimitError';
    this.retryAfterSeconds = retryAfterSeconds;
  }
}

// Preserves the original `.name` for downstream code that fingerprints
// errors by `error.name` (Sentry, log lines).
export class SharedReportRateLimitError extends DashMetaRateLimitError {
  constructor(retryAfterSeconds: number) {
    super(retryAfterSeconds);
    this.name = 'SharedReportRateLimitError';
  }
}

const DEFAULT_RETRY_AFTER_SECONDS = 60;

export const parseRetryAfterSeconds = (response: Response): number => {
  const retryAfter = Number(response.headers.get('Retry-After'));
  return Number.isFinite(retryAfter) && retryAfter > 0
    ? retryAfter
    : DEFAULT_RETRY_AFTER_SECONDS;
};
